import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryUsername from "components/Run/elements/HistoryEntryUsername";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunHistoryEntryType } from "../../types";

type RunCanceledEntryProps = {
  timestamp: number;
  note: string | null;
  username: string | null;
};

// TODO: no designs
const RunCanceledEntry = ({ timestamp, note, username }: RunCanceledEntryProps) => {
  const label = (
    <HistoryEntryLabel>
      <strong>Canceled</strong> <HistoryEntryUsername username={username} />
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      label={label}
      state={RunHistoryEntryType.Canceled}
      timestamp={timestamp}
      terminal
    >
      {note && <HistoryEntryNote>{note}</HistoryEntryNote>}
    </HistoryEntryWrapper>
  );
};

export default RunCanceledEntry;
